import 'select2';

export default function initSelect() {
  const tabsContainers = document.querySelectorAll('[data-tabs="study-tabs"]');
  if (!tabsContainers.length) return;

  tabsContainers.forEach((tabsContainer, index) => {
    const selectStudyModes = jQuery('.select-study-modes').eq(index);
    if (!selectStudyModes.length) return;

    // Initialize select2
    selectStudyModes.select2({
      minimumResultsForSearch: Infinity,
      width: '100%',
      templateResult: formatOption,
      templateSelection: formatOption,
    });

    function formatOption(option) {
      if (!option.element) return option.text;

      const titleEl = $(option.element).data('title');
      const textEl = $(option.element).data('text');

      if (!titleEl) return option.text;

      // Return only title if text is not available
      return $(`
        <div class="select-option">
          <span class="select-option-title">${titleEl}</span>
          ${textEl ? `<span class="select-option-text">${textEl}</span>` : ''}
        </div>
      `);
    }

    // Generate options from tabs
    tabsContainer.querySelectorAll('li > a').forEach((tab) => {
      const titleEl = tab.querySelector('.ttl');
      const textEl = tab.querySelector('.txt');

      if (!titleEl) return;

      // Use only title text if text element is not available
      const optionText = textEl ? `${titleEl.textContent} - ${textEl.textContent}` : titleEl.textContent;

      const option = new Option(optionText, tab.getAttribute('href').substring(1));

      // Add data attributes for formatting
      $(option).data('title', titleEl.textContent);
      if (textEl) {
        $(option).data('text', textEl.textContent);
      }

      selectStudyModes.append(option);
    });

    // Handle select change
    selectStudyModes.on('change', function (e) {
      const tab = tabsContainer.querySelector(`a[href="#${e.target.value}"]`);
      tab?.click();
    });

    // Set initial value
    const defaultTab = tabsContainer.querySelector('[data-tabby-default]');
    if (defaultTab) {
      selectStudyModes.val(defaultTab.getAttribute('href').substring(1)).trigger('change');
    }
  });

  // Handle resize
  const handleResize = () => {
    const select2Containers = document.querySelectorAll('.select2-container');
    const tabsContainers = document.querySelectorAll('[data-tabs="study-tabs"]');

    if (!select2Containers.length || !tabsContainers.length) return;

    const isDesktop = window.innerWidth >= 1024;

    select2Containers.forEach((select2Container, index) => {
      // Check if corresponding tabs container exists
      const tabsContainer = tabsContainers[index];
      if (!tabsContainer) return;

      select2Container.style.display = isDesktop ? 'none' : '';
      tabsContainer.style.display = isDesktop ? '' : 'none';
    });
  };

  handleResize();
  window.addEventListener('resize', handleResize);
}
